export default __webpack_public_path__ + "static/media/chevron down.33f23cca.svg";